import ImportFCL from '../ImportFCL/ImportFCL';

const VacioImportacion = () => {
  return <ImportFCL tipo="VacioImportacion" />;
};

export default VacioImportacion;
